// extracted by mini-css-extract-plugin
export default {"card":"M4-z"};